import $ from "jquery";

// Must run before Bootstrap UMD so window.jQuery is defined.
window.jQuery = window.$ = $;

export default $;
